// removed by extract-text-webpack-plugin
module.exports = {"banner":"qempo_TopBanner_banner-3Ixroy8","loading":"qempo_TopBanner_loading-1E5KM80"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/new-order/components/TopBanner/TopBanner.scss
// module id = 1652
// module chunks = 0